import React from 'react';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import * as Sentry from '@sentry/react';

// Routes
import routes from '../../routes/routes';
import { createDynamicRoutes } from '../../routes/dynamicRoutes';

// Services
import { useManagerPages } from '../../services/pages/pagesQueries';

// Components
import Page from './Page/Page';

/**
 * Router with dynamic routes loaded from API
 * @returns {JSX.Element}
 */
function DynamicRouter() {
  const isTokenRoute = window.location.pathname === '/token';
  const {
    data: pagesResponse,
  } = useManagerPages({ enabled: !isTokenRoute });

  const router = React.useMemo(() => {
    const sentryCreateBrowserRouter = Sentry.wrapCreateBrowserRouter(createBrowserRouter);
    if (!pagesResponse?.pages?.length) {
      return sentryCreateBrowserRouter([
        {
          path: '*',
          element: <Page page={{ template: 'table', path: '', format: null }} />,
        },
        ...routes,
      ]);
    }

    const dynamicRoutes = createDynamicRoutes(pagesResponse?.pages);

    return sentryCreateBrowserRouter([
      ...routes,
      ...dynamicRoutes,
    ]);
  }, [pagesResponse?.pages]);

  return <RouterProvider router={router} />;
}

export default DynamicRouter;
